var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('widget', [_c('widget-header', {
    staticClass: "background-gradient-green-blue text-white tiny-forms"
  }, [_c('i', {
    staticClass: "zmdi zmdi-file-plus pr-2"
  }), _vm._v(" New Payment info "), _c('h4', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('close-x', {
    staticClass: "text-white",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1)]), _c('widget-body', [_c('div', {
    staticClass: "grid grid-cols-1 gap-y-2"
  }, [_c('Superselect', {
    attrs: {
      "title": "Select Payment Type",
      "multiple": false,
      "required": true,
      "options": ['Crypto Wallet (BTC)', 'Bank Transfer (via Wise)']
    },
    model: {
      value: _vm.paymentType,
      callback: function ($$v) {
        _vm.paymentType = $$v;
      },
      expression: "paymentType"
    }
  }), _vm.paymentType && _vm.paymentType == 'Crypto Wallet (BTC)' ? _c('div', [_c('YInput', {
    attrs: {
      "label": "Wallet Id",
      "required": _vm.paymentType == 'Crypto Wallet (BTC)' ? true : false,
      "error": _vm.validationErrorFields.includes('walletId')
    },
    model: {
      value: _vm.walletId,
      callback: function ($$v) {
        _vm.walletId = $$v;
      },
      expression: "walletId"
    }
  })], 1) : _vm._e(), _vm.paymentType && _vm.paymentType == 'Bank Transfer (via Wise)' ? _c('div', {
    staticClass: "grid grid-cols-1 gap-y-2"
  }, [_c('Superselect', {
    attrs: {
      "title": "Select Currency",
      "track-by": "code",
      "label": "code",
      "multiple": false,
      "options": _vm.wiseCurrencies || [],
      "loading": _vm.$apollo.queries.wiseCurrencies.loading,
      "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false,
      "error": _vm.validationErrorFields.includes('wiseCurrency')
    },
    model: {
      value: _vm.currency,
      callback: function ($$v) {
        _vm.currency = $$v;
      },
      expression: "currency"
    }
  }), _vm.currency ? _c('Superselect', {
    attrs: {
      "title": "Payment Method",
      "track-by": "key",
      "label": "title",
      "multiple": false,
      "options": this.payOptions || [],
      "loading": _vm.$apollo.queries.wiseAccountDetails.loading,
      "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false,
      "error": _vm.validationErrorFields.includes('payOption')
    },
    model: {
      value: _vm.payOption,
      callback: function ($$v) {
        _vm.payOption = $$v;
      },
      expression: "payOption"
    }
  }) : _vm._e(), _vm.payOption ? _c('div', {
    staticClass: "grid grid-cols-1 gap-y-2"
  }, [_c('YInput', {
    attrs: {
      "error": _vm.validationErrorFields.includes('filters.name.fullName'),
      "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false,
      "label": "Account Holder"
    },
    model: {
      value: _vm.filters.name.fullName,
      callback: function ($$v) {
        _vm.$set(_vm.filters.name, "fullName", $$v);
      },
      expression: "filters.name.fullName"
    }
  }), _c('YInput', {
    attrs: {
      "label": "Payment Notifications Email",
      "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false
    },
    model: {
      value: _vm.filters.aDetails['email'],
      callback: function ($$v) {
        _vm.$set(_vm.filters.aDetails, 'email', $$v);
      },
      expression: "filters.aDetails['email']"
    }
  }), _vm._l(_vm.getAccountRequirements, function (value, key) {
    return _c('div', {
      key: key,
      staticClass: "grid grid-cols-1 gap-y-2"
    }, [value.fieldType == 'input' || value.fieldType == 'text' ? _c('div', [_c('YInput', {
      attrs: {
        "label": value === null || value === void 0 ? void 0 : value.name,
        "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false,
        "error": _vm.validationErrorFields.includes(value === null || value === void 0 ? void 0 : value.name)
      },
      model: {
        value: _vm.filters.aDetails[value === null || value === void 0 ? void 0 : value.key],
        callback: function ($$v) {
          _vm.$set(_vm.filters.aDetails, value === null || value === void 0 ? void 0 : value.key, $$v);
        },
        expression: "filters.aDetails[value?.key]"
      }
    })], 1) : _vm._e(), value.fieldType == 'select' ? _c('div', [_c('Superselect', {
      attrs: {
        "title": value === null || value === void 0 ? void 0 : value.name,
        "track-by": "name",
        "label": "name",
        "multiple": false,
        "options": (value === null || value === void 0 ? void 0 : value.valuesAllowed) || [],
        "loading": _vm.$apollo.queries.wiseCurrencies.loading,
        "required": _vm.paymentType != 'Crypto Wallet (BTC)' ? true : false,
        "error": _vm.validationErrorFields.includes('wiseCurrency')
      },
      model: {
        value: _vm.filters.aDetails[value === null || value === void 0 ? void 0 : value.key],
        callback: function ($$v) {
          _vm.$set(_vm.filters.aDetails, value === null || value === void 0 ? void 0 : value.key, $$v);
        },
        expression: "filters.aDetails[value?.key]"
      }
    })], 1) : _vm._e()]);
  })], 2) : _vm._e()], 1) : _vm._e(), _vm.paymentType && _vm.paymentType == 'Crypto Wallet (BTC)' ? _c('YButton', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.saveBitcoinWallet();
      }
    }
  }, [_vm._v(" Create Bitcoin Pay Option ")]) : _vm._e(), _vm.paymentType && _vm.paymentType == 'Bank Transfer (via Wise)' ? _c('YButton', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.saveWisePayment();
      }
    }
  }, [_vm._v(" Create Bank Transfer Pay Option ")]) : _vm._e()], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }